export default "__VITE_PUBLIC_ASSET__ae80f860__"